import {
  faCalendarAlt,
  faCartPlus,
  faClock,
  faTimesCircle,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { renderFormulaList } from "../../actions/formulaAction";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import {
  clearUnfinalizedPrescription,
  practitonerPrescriptionPostAction,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import { formatDate, getUserDetail } from "../../utils/helper";

const PrescriptionListPopup = ({
  closePopup,
  prescriptionRow,
  setActiveSection,
  clearPrescriptionValue,
  setPatientName,
  setPatientFirstName,
  setPatientLastName,
  setPatientEmail,
  setPatientPhone,
  setFullscriptId,
  setPatientID,
  setPpcId,
  cartItems,
  fromFullscript,
  setPatientInstruction,
  setNotesOnPrescription,
  setPharmacyInsytruction,
}) => {
  const dispatch = useDispatch();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [activePrescription, setActivePrescription] = useState(0);
  const [prescriptions, setPrescriptions] = useState([]);
  const role = useSelector((state) => state.role.role);
  const appLoading = useSelector((state) => state.alert.appLoading);
  useEffect(() => {
    setPrescriptions(prescriptionRow.prescriptions);
  }, [prescriptionRow]);

  const cancelPrescription = () => {
    if (appLoading || activePrescription < 1) {
      return;
    }
    const data = {
      action: "cancelPrescription",
      prescription_id: activePrescription,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(
      practitonerPrescriptionPostAction(params, () => {
        dispatch(getCreatePrescriptionPatients());
        setPrescriptions(
          prescriptions.filter((x) => x.Prescription_ID !== activePrescription)
        );
        setActivePrescription(0);
        if (
          cartItems.some(
            (item) =>
              item.prescriptionId == activePrescription && item.itemType == 1
          )
        ) {
          let roleId = role.val == 3 ? role.val : role.val == 4 ? role.val : 1;
          var params = {
            params: {
              action: "removeCartItem",
              itemId: activePrescription,
              itemType: 1,
              roleId: roleId,
              token: getUserDetail()?.token,
            },
          };
          dispatch(
            cartPostAction(params, () => {
              dispatch(getCartItems(role.val));
              dispatch(getPatientNotification(role.val));
            })
          );
        }
      })
    );
  };

  const loadPrescription = (id) => {
    if (fromFullscript) {
      dispatch(prescriptionPageTabShowItemList([1]));
      dispatch(clearUnfinalizedPrescription());
      dispatch(setUnfinalizedPrescriptionId(id));
      clearPrescriptionValue();
      setPatientInstruction("");
      setPharmacyInsytruction("");
      setNotesOnPrescription("");
      dispatch(renderFormulaList(true));
      setActiveSection(1);
      closePopup();
      setTimeout(() => {
        dispatch(prescriptionPageTabShowItemList([1, 2]));
      }, 10);
    } else {
      dispatch(prescriptionPageTabShowItemList([1]));
      dispatch(clearUnfinalizedPrescription());
      dispatch(setUnfinalizedPrescriptionId(id));
      setPatientInstruction("");
      setPharmacyInsytruction("");
      setNotesOnPrescription("");
      clearPrescriptionValue();
      dispatch(renderFormulaList(true));
      closePopup();
      if (prescriptionRow?.Fullscript_ID) {
        setTimeout(() => {
          dispatch(prescriptionPageTabShowItemList([1, 2]));
        }, 10);
        setActiveSection(1);
      } else {
        setTimeout(() => {
          dispatch(prescriptionPageTabShowItemList([1, 3]));
        }, 10);
        setActiveSection(2);
      }
    }
  };

  const createNewPrescription = (id) => {
    dispatch(prescriptionPageTabShowItemList([1]));
    setPatientID(prescriptionRow.Patient_ID);
    setPpcId(prescriptionRow.PPC_ID);
    setPatientName(
      `${prescriptionRow.First_Name} ${prescriptionRow.Last_Name}`
    );
    setPatientFirstName(prescriptionRow?.First_Name);
    setPatientLastName(prescriptionRow?.Last_Name);
    setPatientEmail(prescriptionRow?.Email);
    setPatientPhone(prescriptionRow?.Phone);
    setFullscriptId(
      prescriptionRow.Fullscript_ID ? prescriptionRow.Fullscript_ID : 0
    );
    dispatch(clearUnfinalizedPrescription());
    dispatch(setUnfinalizedPrescriptionId(0));
    setPatientInstruction("");
    setPharmacyInsytruction("");
    setNotesOnPrescription("");
    clearPrescriptionValue();
    dispatch(renderFormulaList(true));
    if (fromFullscript) {
      setActiveSection(1);
      setTimeout(() => {
        dispatch(prescriptionPageTabShowItemList([1, 2]));
      }, 10);
    } else {
      if (prescriptionRow?.Fullscript_ID) {
        setTimeout(() => {
          dispatch(prescriptionPageTabShowItemList([1, 2]));
        }, 10);
        setActiveSection(1);
      } else {
        setTimeout(() => {
          dispatch(prescriptionPageTabShowItemList([1, 3]));
        }, 10);
        setActiveSection(2);
      }
    }

    closePopup();
  };

  const prescriptionInfo = prescriptions?.map((x) => (
    <div key={x.Prescription_ID} className="prescription-item-list">
      <div>
        <p>
          Prescription #<span className="bold-text">{x.Prescription_ID}</span>{" "}
          {x.FORM_Custom && ` - ${x.FORM_Custom}`}
          <span className="cart-text">
            {cartItems.some(
              (item) =>
                item.prescriptionId == x.Prescription_ID && item.itemType == 1
            ) ? (
              <>
                (Currently In Your Shopping Cart{" "}
                <FontAwesomeIcon icon={faCartPlus} color="orange" /> )
              </>
            ) : null}
          </span>
        </p>
        <p>
          Last Saved Date:
          <span className="bold-text">
            <FontAwesomeIcon icon={faCalendarAlt} color="gray" />{" "}
            {formatDate(x.Last_Saved_Date)}
          </span>
          <span className="bold-text">
            <FontAwesomeIcon icon={faClock} color="gray" />{" "}
            {new Date(x.Last_Saved_Date).toLocaleTimeString()}
          </span>
        </p>
      </div>
      <div className="actions d-flex align-items-center">
        <button
          className="btn-orange"
          onClick={() => loadPrescription(x.Prescription_ID)}
        >
          Load
        </button>
        <div
          className="trash-icon"
          onClick={() => {
            setShowConfirmDialog(true);
            setActivePrescription(x.Prescription_ID);
          }}
        >
          <FontAwesomeIcon icon={faTrashAlt} color="red" />
        </div>
      </div>
    </div>
  ));
  return (
    <Modal size="xl" show={true} backdrop="static">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Choose Prescription</h5>
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          {showConfirmDialog && (
            <ConfirmDialog
              title={
                cartItems.some(
                  (item) =>
                    item.prescriptionId == activePrescription &&
                    item.itemType == 1
                )
                  ? "Are you sure want to cancel this prescription? Prescription will be removed from your shopping cart"
                  : "Are you sure want to cancel this prescription?"
              }
              acceptAction={cancelPrescription}
              acceptText="yes"
              rejectText="no"
              closePopup={() => setShowConfirmDialog(false)}
            />
          )}
          {prescriptionInfo}
        </>
      </Modal.Body>
      {/* <Modal.Footer>
        <div className="submit-section">
          <button className="btn-orange" onClick={createNewPrescription}>
            Add New
          </button>
        </div>
      </Modal.Footer> */}
    </Modal>
  );
};
export default PrescriptionListPopup;
